
import { generateID } from '@/common/utils/helpers';
import { defineComponent, PropType } from 'vue';
import AppError, { type VuelidateValidation } from '@/components/Error.vue';

export default defineComponent({
    name: 'AppSwitch',
    components: { AppError },
    props: {
        modelValue: { type: Boolean, default: false },
        validations: { type: Object as PropType<VuelidateValidation>, default: undefined },
        disabled: { type: Boolean, default: false }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const ID: string = generateID();

        function onValueChange(event: any) {
            emit('update:modelValue', event.target.checked);
            props.validations?.$touch();
        }

        return { ID, onValueChange };
    }
});
